/**
 * Turn an API validation code into a user-facing sentence.
 * Never returns a dotted API key (e.g. validation.imputation_level1).
 */
export function resolveValidationMessage(t, rawMessage) {
    const generic = typeof t?.read === "function" ? t.read("validation.generic") : "";
    const fallback = typeof generic === "string" && generic.trim() ? generic : "";
    if (typeof rawMessage !== "string" || !rawMessage.trim()) {
        return fallback;
    }
    let translated;
    try {
        translated = t.read(rawMessage);
    } catch {
        return fallback;
    }
    if (typeof translated !== "string" || !translated.trim()) {
        return fallback;
    }
    if (translated === rawMessage && rawMessage.includes(".")) {
        return fallback;
    }
    return translated;
}

/** Prefix the sentence with the shared "Validation error" label used on expense Validate. */
export function formatValidateExpenseError(t, rawMessage) {
    const prefix = typeof t?.read === "function" ? t.read("validation_error") : "";
    const detail = resolveValidationMessage(t, rawMessage);
    if (detail && prefix) {
        return `${prefix} : ${detail}`;
    }
    return detail || prefix || "";
}
